import React, { useState, useEffect } from "react";
import { requestForToken, onMessageListener } from "./firebaseConfig";
import { toast } from "react-toastify";

const PushNotification = () => {
  const [notification, setNotification] = useState({ title: "", body: "" });

  useEffect(() => {
    if (notification.body !== "" || notification.title !== "") {
      toast(`${notification.title}  *  ${notification.body}`, {});
    }
  }, [notification]);

  requestForToken();

  onMessageListener()
    .then((payload: any) => {
      if (!payload) return;
      if (!payload.notification) return;
      console.log(payload);
      setNotification({
        title: payload?.notification?.title,
        body: payload?.notification?.body,
      });
    })
    .catch((err) => console.log("failed: ", err));

  return <>{}</>;
};

export default PushNotification;
